import React from "react";
import { useTranslation } from "react-i18next";
import { Tooltip, ToggleButton, ToggleButtonProps } from "@mui/material";
import ChartTypeIcon from "./ChartTypeIcon";
import { typeTooltip } from "./const";
import { GraphType } from "@services/monitoring/types";

type ChartTypeTitleProps = ToggleButtonProps & { chartType: GraphType };

const ChartTypeTitle = ({
  chartType,
  ...toggleButtonProps
}: ChartTypeTitleProps) => {
  const { t } = useTranslation();

  return (
    <Tooltip arrow title={t(typeTooltip[chartType]!)}>
      <ToggleButton {...toggleButtonProps} size="small">
        <ChartTypeIcon graphType={chartType} />
      </ToggleButton>
    </Tooltip>
  );
};

export default ChartTypeTitle;
